const Terminos = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-black uppercase italic">Términos y Condiciones de Compra</h1>

      <p>
        Las compras realizadas en SANAN están sujetas a los presentes Términos y Condiciones.
      </p>

      <p>
        Los precios se muestran en euros e incluyen los impuestos aplicables.
      </p>

      <p>
        El pago se realiza a través de Stripe mediante los métodos disponibles en la plataforma.
      </p>

      <p>
        El plazo de entrega dependerá del destino y del método de envío seleccionado.
      </p>

      <p>
        El cliente dispone de un plazo de 14 días naturales desde la recepción del pedido para ejercer su derecho de desistimiento, salvo en los casos legalmente excluidos.
      </p>

      <p>
        Para cualquier controversia, será de aplicación la legislación española.
      </p>
    </div>
  );
};

export default Terminos;
